import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Down: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-wall-2-down, align bottom"><path d="M7.75 14.5L12 18.75L16.25 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 20.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 3.75V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowWall2Down;
